export default {
  'menuSettings.showMemberPrice': '显示会员价',
  'menuSettings.defaultWeightForOpenPriceDishes': '设置开价菜默认重量单位',
  'menuSettings.weightNoUnit': '无重量单位',
};
